<template>
  <div>
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: {
    invitations: Object
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const chartData = {
        labels: ['Total', 'Not Arrived', 'Gold', 'Silver', 'Platinum'],
        datasets: [
          {
            label: 'Invitations',
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(54, 162, 235, 0.4)',
            hoverBorderColor: 'rgba(54, 162, 235, 1)',
            data: [
              this.invitations.total,
              this.invitations.notArrived,
              this.invitations.gold,
              this.invitations.silver,
              this.invitations.platinum,
            ],
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            label += tooltipItem.yLabel;
            return label;
          }
        }
      },
      // Add labels for each bar
      legend: {
        display: true,
        labels: {
          fontSize: 14,
          fontColor: 'black'
        }
      }
      };

      const ctx = this.$refs.chart.getContext('2d');
      new Chart(ctx, {
        type: 'bar',
        data: chartData,
        options: chartOptions,
      });
    },
  },
};
</script>

<style scoped>
canvas {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// InvitationsChart.vue?00e8954b